import { get, post, axios } from "../../http/instance";

/**
 * Get tagihan pelanggan by kode_pelanggan
 * @param {string} kode_pelanggan - Nomor sambung pelanggan
 * @returns {Promise} Response dari API
 */
export const getTagihanPelanggan = async (kode_pelanggan) => {
  const response = await get(`tagihanv2/tagihan_pelanggan/${kode_pelanggan}`, {
    kode_pelanggan: kode_pelanggan,
  });
  return response;
};

/**
 * Get tagihan pelanggan by kode_pelanggan (POST method)
 * @param {string} kode_pelanggan - Nomor sambung pelanggan
 * @returns {Promise} Response dari API
 */
export const postTagihanPelanggan = async (kode_pelanggan) => {
  const response = await post(`v2/tagihan_pelanggan`, {
    kode_pelanggan: kode_pelanggan,
  });
  return response;
};

/**
 * Get detail tagihan by id_bill_invoice (Public API)
 * @param {string} id_bill_invoice - ID bill invoice
 * @returns {Promise} Response dari API
 */
export const getDetailTagihanPublic = async (id_bill_invoice) => {
  const response = await get(
    `public/service/detail-tagihan/${id_bill_invoice}`,
  );
  return response;
};

/**
 * Request payment URL from Finnet
 * @param {string} kode_pelanggan - Nomor sambung pelanggan
 * @returns {Promise} Response dari API containing payment URL
 */
export const postPaymentFinnet = async (kode_pelanggan) => {
  const response = await post(`payment-finnet`, {
    kode_pelanggan: kode_pelanggan,
  });
  return response;
};

/**
 * Kirim struk tagihan ke email pelanggan
 * @param {string} id_tagihan - ID tagihan
 * @param {string} kode_pelanggan - Nomor sambung pelanggan
 * @param {string} email - Alamat email tujuan
 * @returns {Promise} Response dari API
 */
export const kirimStrukEmail = async ({
  id_tagihan,
  kode_pelanggan,
  email,
}) => {
  const response = await post(`tagihanv2/kirim_struk_email`, {
    id_tagihan,
    kode_pelanggan,
    email,
  });
  return response;
};

/**
 * Kirim pengaduan pelanggan (whistleblower)
 * @param {Object} payload - Data pengaduan
 * @returns {Promise} Response dari API
 */
export const postPengaduan = async (payload) => {
  const response = await post(`pengaduan/mobile/create`, payload);
  return response;
};

/**
 * Kirim laporan whistleblower
 * @param {FormData} formData - Data laporan pelanggaran
 * @returns {Promise} Response dari API
 */
export const postWhistleblower = async (payload) => {
  const response = await axios.post(
    "https://api-external.perumdamcm.kawandev.xyz/api/v1/whistleblower/",
    payload,
    { headers: { "Content-Type": "application/json" } },
  );
  return response;
};

/**
 * Registrasi pelanggan baru
 * @param {FormData} formData - Data registrasi pelanggan dalam bentuk FormData
 * @returns {Promise} Response dari API
 */
export const postRegistrasiPelanggan = async (formData) => {
  const response = await axios.post(
    "https://api-external.perumdamcm.kawandev.xyz/api/v1/pelanggan/register",
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    },
  );
  return response;
};
